import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/**
 * Hook para obtener las opciones de catálogo de Área Comercial.
 * Incluye tipos de OT, columnas por tipo, requerimientos y precios.
 */
export function useCatalogsComercial() {
  const { data: items = [], isLoading } = useQuery({
    queryKey: ["catalogs-comercial"],
    queryFn: async () => (await api.get("/ots-comercial/catalogos")).data,
    staleTime: 60000,
  });

  const { data: columnasConfig = [] } = useQuery({
    queryKey: ["columnas-partidas-ac"],
    queryFn: async () => (await api.get("/ots-comercial/columnas-partidas")).data,
    staleTime: 60000,
  });

  const opts = useMemo(() => {
    const byType = (tipo) => items.filter((i) => i.tipo === tipo && i.activo !== false).map((i) => i.nombre);
    return {
      clientes: byType("cliente_ac"),
      solicitantes: byType("solicitante_ac"),
      formas_pago: byType("forma_pago_ac"),
      areas: byType("area_ac"),
      tipos_trabajo: byType("tipo_trabajo_ac"),
      requerimientos_ot: byType("requerimientos_ot_ac"),
      autorizaciones: byType("autorizacion_ac"),
      tipos_ot: byType("tipo_ot_ac"),
      precios_tipo_trabajo: byType("precios_tipo_trabajo_ac"),
    };
  }, [items]);

  // Map: tipo_trabajo nombre -> precio (from precios_tipo_trabajo_ac catalog)
  const preciosMap = useMemo(() => {
    const map = {};
    for (const item of items) {
      if (item.tipo === "precios_tipo_trabajo_ac" && item.activo !== false && item.precio !== undefined) {
        map[item.nombre] = item.precio;
      }
    }
    return map;
  }, [items]);

  // Map: tipo_ot name -> columnas[]
  const columnasMap = useMemo(() => {
    const map = {};
    for (const cfg of columnasConfig) {
      map[cfg.tipo_ot] = cfg.columnas || [];
    }
    return map;
  }, [columnasConfig]);

  return { opts, isLoading, columnasConfig, columnasMap, preciosMap };
}
